/* Custom Handlebars helper methods */
/* eslint-disable */
(function() {
  var Handlebars = require('handlebars');
  var moment = require('moment');

  Handlebars.registerHelper('image', function(url, alt) {
    alt = Handlebars.escapeExpression(alt);
    url = Handlebars.escapeExpression(url);

    return new Handlebars.SafeString('<img alt="' + alt + '" src="' + url + '" />');
  });

  Handlebars.registerHelper('link', function(url, text, css) {
    url = Handlebars.escapeExpression(url);
    text = Handlebars.escapeExpression(text);

    if (url.length > 0 && text.length > 0) {
      return new Handlebars.SafeString(
        '<a href="' + url + '" class="' + css + '" title="' + text + '">' + text + '</a>',
      );
    } else {
      return '';
    }
  });

  Handlebars.registerHelper('linknewwindow', function(url, text, css) {
    url = Handlebars.escapeExpression(url);
    text = Handlebars.escapeExpression(text);

    if (url.length > 0 && text.length > 0) {
      return new Handlebars.SafeString(
        '<a href="' +
          url +
          '" class="' +
          css +
          '" title="' +
          text +
          '" target="_blank">' +
          text +
          '</a>',
      );
    } else {
      return '';
    }
  });

  var DateFormats = {
    short: 'DD/MM/YY',
    long: 'dddd DD/MM/YYYY HH:mm',
  };

  Handlebars.registerHelper('formatDate', function(datetime, format) {
    var d = new Date(Date.parse(datetime));

    if (d.getFullYear() > 2001) {
      if (moment) {
        var f = DateFormats[format];
        return '- ' + moment(datetime).format(f);
      } else {
        return '- ' + datetime;
      }
    } else {
      return '';
    }
  });

  Handlebars.registerHelper('getRowDivSep', function(index, mod, isLast) {
    if (index % mod === 0) {
      return new Handlebars.SafeString('</div><div class="row">');
    } else {
      return '';
    }
  });

  Handlebars.registerHelper('getArticleOverlay', function(date, articleType) {
    var d = new Date(Date.parse(date));

    if (d.getFullYear() > 2001) {
      return new Handlebars.SafeString(
        "<span class='hover-overlay'></span><div class='overlay " + articleType + "'></div>",
      );
    } else {
      return '';
    }
  });

  Handlebars.registerHelper('renderTags', function(documentTags, delimiter) {
    var arrTags = documentTags
      .replace(/\'/g, '')
      .replace(/, /g, ',')
      .split(',');
    var strOut = '';
    if (arrTags.length > 0) {
      strOut += '<ul>';
      for (let i = 0; i < arrTags.length; i++) {
        var prepend = delimiter.length > 0 && strOut.length > 4 ? delimiter + ' ' : '';
        strOut += prepend + "<li><a href='?tag=" + arrTags[i] + "'>" + arrTags[i] + '</a></li>';
      }
      strOut += '</ul>';
    }
    return strOut;
  });

  Handlebars.registerHelper('ifcontains', function(conditional, options) {
    if (conditional.toUpperCase().indexOf(options.hash.value.toUpperCase()) > 0) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });
})();
